export function deleteUnnecessaryProperties<S>(listDto: S): S {
  const _listDto = { ...listDto };
  // @ts-ignore
  Object.keys(_listDto).forEach(
    // @ts-ignore
    (key) => (_listDto[key] === undefined || _listDto[key] === null) && delete _listDto[key],
  );
  return _listDto;
}
